import React, { useContext } from "react";
import { VendorContext } from "../../context";
import styles from "./components/General.module.css";

const config = require("../../config");

const PSAccepted = () => {
  const { logo } = useContext(VendorContext);
  return (
    <React.Fragment>
      {logo ? (
        <div className={styles.vendorLogoWrapper}>
          <img
            src={logo && logo.includes("/") ? `https://${config.S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${logo}` : `https://credit-app-images.s3-us-west-2.amazonaws.com/${logo}`}
            alt="Vendor Logo"
          />
        </div>
      ) : (
        ""
      )}
      <br></br>
      <span className={styles.cardTitle}>Payment Option already accepted.</span>
      <p>It appears as though your selection has already been made. Please allow us to get back to you regarding your decision.</p>
      <p>If you have any questions, please give us a call.</p>
    </React.Fragment>
  );
};

export default PSAccepted;
